import { createAction, props } from '@ngrx/store';
import { PaymentMandateRequest } from '../../payment-mandate/models/payment-mandate.model';
import { ICard } from '../models/card.model';

export const loadAddCreditCards = createAction('[AddCreditCard] Load AddCreditCards', props<{ saveCard: PaymentMandateRequest }>());
